import { getPointListApi, getPointCountApi } from "api/point";
import { chargePointApi } from "api/user";

/// ✅ 내 포인트 내역
export const getPointList = async (id, amount, _lastCreateDate) => {
  try {
    const list = await getPointListApi(id);
    if (!Array.isArray(list)) return [];
    if (!amount) return list;
    return list.slice(0, amount);
  } catch (error) {
    console.error("failed getPointList:", error);
    return [];
  }
};

export const getPointListPrev = async (id, amount, _date) => {
  try {
    const list = await getPointListApi(id);
    if (!Array.isArray(list)) return [];
    if (!amount) return list.slice().reverse();
    return list.slice(-amount).reverse();
  } catch (error) {
    console.error("failed getPointListPrev:", error);
    return [];
  }
};

export const getPointListCount = async (id) => {
  try {
    return await getPointCountApi(id);
  } catch (error) {
    console.error("failed getPointListCount:", error);
    return 0;
  }
};

/// 포인트 충전 — 서버의 /post/user/chargePoint 가 원자적으로 처리.
export const chargePoint = async (userId, point) => {
  try {
    const result = await chargePointApi({ userId, point });
    return !!(result && result.success);
  } catch (err) {
    console.error("chargePoint 실패:", err);
    return false;
  }
};
